'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');

var InputDiv = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  margin-bottom: 0.5rem;\n\n  .error-text {\n    margin-bottom: 10px;\n  }\n"], ["\n  margin-bottom: 0.5rem;\n\n  .error-text {\n    margin-bottom: 10px;\n  }\n"])));
var ErrorText = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  color: ", ";\n  margin-top: 10px;\n  &:empty {\n    display: none;\n  }\n"], ["\n  color: ", ";\n  margin-top: 10px;\n  &:empty {\n    display: none;\n  }\n"])), getThemeProp('palette.error.dark', 'red'));
ErrorText.defaultProps = {
    className: 'error-text',
};
var templateObject_1, templateObject_2;

exports.ErrorText = ErrorText;
exports.InputDiv = InputDiv;
